// src/App.js - עם ניתוב מעודכן לקטגוריות והשוואות
import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import ProductPage from './pages/ProductPage';
import NewHomePage from './pages/HomePage';
import ContactPage from './pages/ContactPage';
import './App.css';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import FloatingContactButton from './components/FloatingContactButton';
import FloatingBackToTopButton from './components/FloatingBackToTopButton';
import AdminLoginPage from './pages/admin/LoginPage';
import AdminDashboard from './pages/admin/DashboardPage';
import LeadsPage from './pages/admin/LeadsPage';
import FinancialDictionaryPage from './pages/FinancialDictionaryPage';
import DataManagementPage from './pages/admin/DataManagementPage';
import SourceViewPage from './pages/admin/SourceViewPage';
import ProtectedRoute from './components/ProtectedRoute';
import PrivacyPage from './pages/PrivacyPage';
import AccessibilityPage from './pages/AccessibilityPage';
import TermsPage from './pages/TermsPage';
import AccessibilityMenu from './components/AccessibilityMenu';
import AboutPage from './pages/AboutPage';
import FundDetailsPage from './pages/admin/FundDetailsPage';
import CategoryPage from './pages/CategoryPage';
import RouteScanner from './components/RouteScanner';

import ProductComparison from './components/ProductComparison';
// ייבוא דפי המשתמש החדשים
import LoginPage from './pages/auth/LoginPage';
import RegisterPage from './pages/auth/RegisterPage';
import ForgotPasswordPage from './pages/auth/ForgotPasswordPage';
import ProfilePage from './pages/ProfilePage';
import CompleteProfilePage from './pages/auth/CompleteProfilePage';
import './styles/animations.css';
// ייבוא AuthProvider
import { AuthProvider } from './context/AuthContext';

// 🆕 ייבוא רכיבי ההגנה המשפטית
import LegalConsentCheckboxes from './components/legal/LegalConsentCheckboxes';
import CookieBanner from './components/legal/CookieBanner';
import CookiePolicyPage from './components/legal/CookiePolicyPage';
import LegalDisclaimerPage from './components/legal/LegalDisclaimerPage';

const AppContent = () => {
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  const isAdminPage = location.pathname.startsWith('/admin');
  const isAuthPage = location.pathname.startsWith('/auth');

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <div id="accessibility-wrapper" className="flex flex-col flex-grow">
        {/* נאבבר - רק לא בדף הבית ולא באדמין ולא בדפי התחברות */}
        {!isAdminPage && <Navbar />}
        
        {/* רכיבים רחפים - רק לא באדמין ולא בדפי התחברות */}
        {!isAdminPage && !isAuthPage && (
          <>
            <FloatingContactButton />
            <AccessibilityMenu />
            <FloatingBackToTopButton />
          </>
        )}
      
        {/* תוכן ראשי */}
        <main className={`flex-grow ${!isHomePage && !isAdminPage && !isAuthPage ? "pt-8 md:pt-10" : ""}`}>
          <Routes>
            {/* דף הבית */}
            <Route path="/" element={<NewHomePage />} />
            
            {/* Route עם פרמטר דינמי */}
            <Route path="/compare/:category" element={<NewHomePage />} />
            
            {/* תמיכה בראוטים הישנים */}
            <Route path="/study-funds" element={<NewHomePage defaultCategory="study-funds" />} />
            <Route path="/pension-savings" element={<NewHomePage defaultCategory="pension-savings" />} />
            <Route path="/investment-funds" element={<NewHomePage defaultCategory="investment-funds" />} />
            <Route path="/insurance-savings" element={<NewHomePage defaultCategory="insurance-savings" />} />
            <Route path="/pension-funds" element={<NewHomePage defaultCategory="pension-funds" />} />
            <Route path="/child-savings" element={<NewHomePage defaultCategory="child-savings" />} />
            
            {/* סורק מסלולים - נתיב כללי */}
           <Route path="/route-scanner" element={<RouteScanner />} />
<Route path="/route-scanner/:category" element={<RouteScanner />} />
<Route path="/route-scanner/compare/:fundIds" element={<ProductComparison />} />
       
  
            {/* דפי מוצר וצור קשר */}
            <Route path="/product/:category/:productId" element={<ProductPage />} />
            <Route path="/category/:categoryId" element={<CategoryPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/dictionary" element={<FinancialDictionaryPage />} />
            
            {/* דפי מידע ומשפטיים */}
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/accessibility" element={<AccessibilityPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/about" element={<AboutPage />} />

            {/* 🆕 דפים משפטיים נוספים */}
            <Route path="/cookie-policy" element={<CookiePolicyPage />} />
            <Route path="/legal-disclaimer" element={<LegalDisclaimerPage />} />

            {/* 🆕 נתיבי התחברות משתמשים */}
            <Route path="/auth/login" element={<LoginPage />} />
            <Route path="/auth/register" element={<RegisterPage />} />
            <Route path="/auth/forgot-password" element={<ForgotPasswordPage />} />
<Route path="/auth/complete-profile" element={<CompleteProfilePage />} />
            {/* 🆕 נתיבי משתמש מחובר */}
            <Route 
              path="/user/profile" 
              element={
                <ProtectedRoute requireAuth={true}>
                  <ProfilePage />
                </ProtectedRoute>
              } 
            />
            
            {/* נתיבי מנהל */}
            <Route path="/admin/login" element={<AdminLoginPage />} />
            
            {/* נתיב בסיסי לאדמין - מפנה ללוח בקרה */}
            <Route 
              path="/admin" 
              element={
                <ProtectedRoute requireAdmin={true}>
                  <AdminDashboard />
                </ProtectedRoute>
              } 
            />
            
            {/* לוח בקרה */}
            <Route 
              path="/admin/dashboard" 
              element={
                <ProtectedRoute requireAdmin={true}>
                  <AdminDashboard />
                </ProtectedRoute>
              } 
            />
            
            {/* פניות */}
            <Route 
              path="/admin/leads" 
              element={
                <ProtectedRoute requireAdmin={true}>
                  <LeadsPage />
                </ProtectedRoute>
              } 
            />
            
            {/* ניהול נתונים */}
            <Route 
              path="/admin/data" 
              element={
                <ProtectedRoute requireAdmin={true}>
                  <DataManagementPage />
                </ProtectedRoute>
              } 
            />

            {/* צפייה במקור ספציפי */}
            <Route 
              path="/admin/data/source/:sourceKey" 
              element={
                <ProtectedRoute requireAdmin={true}>
                  <SourceViewPage />
                </ProtectedRoute>
              } 
            />

            <Route 
              path="/admin/fund/:fundId" 
              element={
                <ProtectedRoute requireAdmin={true}>
                  <FundDetailsPage />
                </ProtectedRoute>
              } 
            />

            {/* דף לא נמצא - 404 */}
            <Route 
              path="*" 
              element={
                <div className="min-h-screen flex items-center justify-center">
                  <div className="text-center">
                    <h1 className="text-4xl font-bold text-gray-900 mb-4">404 - דף לא נמצא</h1>
                    <p className="text-gray-600 mb-4">הדף שחיפשת לא נמצא במערכת</p>
                    <p className="text-sm text-gray-500 mb-6">נתיב נוכחי: {location.pathname}</p>
                    <div className="space-y-2">
                      <a 
                        href="/" 
                        className="block bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors"
                      >
                        חזרה לעמוד הבית
                      </a>
                      <a 
                        href="/auth/login" 
                        className="block bg-purple-600 text-white px-6 py-3 rounded-lg hover:bg-purple-700 transition-colors"
                      >
                        התחברות משתמש
                      </a>
                      <a 
                        href="/admin/login" 
                        className="block bg-gray-600 text-white px-6 py-3 rounded-lg hover:bg-gray-700 transition-colors"
                      >
                        כניסת מנהל
                      </a>
                    </div>
                  </div>
                </div>
              } 
            />
          </Routes>
        </main>

        {/* Footer - יופיע בכל הדפים חוץ מאדמין ודפי התחברות */}
        {!isAdminPage && !isAuthPage && <Footer />}

        {/* 🆕 רכיבי הגנה משפטית - יופיעו בכל האתר */}
        {/* באנר עוגיות - יופיע רק בדפים לא אדמין */}
        {!isAdminPage && <CookieBanner />}
      </div>
    </div>
  );
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppContent />
      </Router>
    </AuthProvider>
  );
}

export default App;